/* God Inspires — shipping protection toggle for the cart drawer and cart page.
   On by default; tiered by merchandise subtotal: < $80 → $1.99, $80–149.99 → $3.99, $150+ → $5.99.
   Opting out is saved on the cart as the hidden attribute _gi_sp_off = "1". */
(function () {
  if (window.GIShipProtect) return;
  var HANDLE = 'shipping-protection';
  var TIERS = [
    { below: 8000, title: '1.99' },
    { below: 15000, title: '3.99' },
    { below: Infinity, title: '5.99' }
  ];
  var product = null, busy = false;

  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.json(); });
  }
  function loadProduct() {
    if (product) return Promise.resolve(product);
    return json('/products/' + HANDLE + '.js').then(function (p) { product = p; return p; });
  }
  function isProt(item) { return item.handle === HANDLE || (product && item.product_id === product.id); }
  function tierFor(subtotal) {
    var t = TIERS.find(function (x) { return subtotal < x.below; });
    var v = product.variants.find(function (x) { return x.title === t.title; });
    return v || null;
  }
  function split(cart) {
    var prot = [], others = [], sub = 0;
    cart.items.forEach(function (i) { if (isProt(i)) prot.push(i); else { others.push(i); sub += i.final_line_price; } });
    return { prot: prot, others: others, sub: sub };
  }

  // Make the cart match the rule: one protection line at the right tier, unless opted out or empty.
  function sync(cart) {
    if (busy) return Promise.resolve(cart);
    return loadProduct().then(function () {
      var s = split(cart);
      var off = cart.attributes && cart.attributes._gi_sp_off === '1';
      var want = !off && s.others.length ? tierFor(s.sub) : null;
      var ok = want ? (s.prot.length === 1 && s.prot[0].variant_id === want.id && s.prot[0].quantity === 1) : s.prot.length === 0;
      if (ok) return cart;
      busy = true;
      var updates = {};
      s.prot.forEach(function (i) { updates[i.key] = 0; });
      var step = s.prot.length ? json('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: updates }) }) : Promise.resolve();
      return step
        .then(function () { return want ? json('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: want.id, quantity: 1 }] }) }) : null; })
        .then(function () { return json('/cart.js'); })
        .finally(function () { busy = false; });
    }).catch(function () { return cart; });
  }

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) { try { return Shopify.formatMoney(cents, window.money_format || '${{amount}}'); } catch (e) {} }
    return '$' + (cents / 100).toFixed(2);
  }

  function rowHTML(cart) {
    var s = split(cart);
    if (!s.others.length || !product) return '';
    var on = s.prot.length > 0;
    var fee = tierFor(s.sub);
    return '<div class="gi-sp' + (on ? ' is-on' : '') + '" data-gi-sp>' +
      '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6z"/><path d="M9 12l2 2 4-4"/></svg>' +
      '<div class="gi-sp__text"><strong>Shipping protection · ' + money(fee ? fee.price : 0) + '</strong>' +
      '<span>Covers loss, theft and damage in transit. Remove anytime.</span></div>' +
      '<button type="button" class="gi-sp__switch" role="switch" aria-checked="' + on + '" aria-label="Shipping protection" data-gi-sp-toggle><span></span></button>' +
      '</div>';
  }

  function decorate(cart) {
    document.querySelectorAll('a[href*="/products/' + HANDLE + '"]').forEach(function (a) {
      var line = a.closest('.media-link, tr');
      if (line) line.classList.add('gi-sp-line');
    });
    document.querySelectorAll('[data-gi-sp]').forEach(function (n) { n.remove(); });
    var html = rowHTML(cart);
    if (!html) return;
    [document.querySelector('[data-drawer-body] .cart-btn-container'), document.querySelector('[data-cart-wrapper] .cart-btn')].forEach(function (anchor) {
      if (anchor) anchor.insertAdjacentHTML('beforebegin', html);
    });
    var count = cart.item_count - split(cart).prot.reduce(function (t, i) { return t + i.quantity; }, 0);
    document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = count > 0 ? count : ''; });
  }

  function refresh(cart) {
    if (location.pathname.indexOf('/cart') === 0 && typeof window.cartPageUpdate === 'function') window.cartPageUpdate(cart);
    if (typeof window.buildCart === 'function' && document.querySelector('[data-drawer-body] .yv-cart-drawer')) window.buildCart(cart, true);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gi-sp-toggle]');
    if (!btn) return;
    e.preventDefault();
    var turnOn = btn.getAttribute('aria-checked') !== 'true';
    btn.setAttribute('aria-checked', turnOn);
    btn.closest('[data-gi-sp]').classList.toggle('is-on', turnOn);
    json('/cart/update.js', { method: 'POST', body: JSON.stringify({ attributes: { _gi_sp_off: turnOn ? '' : '1' } }) })
      .then(sync)
      .then(refresh);
  });

  // Wrap the theme's cart renderers so every cart change passes through sync first.
  function wrap() {
    if (typeof window.buildCart === 'function' && !window.buildCart.__gi) {
      var ob = window.buildCart;
      window.buildCart = function (cart, showCart, el) {
        return sync(cart).then(function (c) { ob(c, showCart, el); });
      };
      window.buildCart.__gi = true;
    }
    if (typeof window.cartPageUpdate === 'function' && !window.cartPageUpdate.__gi) {
      var op = window.cartPageUpdate;
      window.cartPageUpdate = function (cart) {
        return sync(cart).then(function (c) { op(c); });
      };
      window.cartPageUpdate.__gi = true;
    }
  }

  // Re-draw the toggle whenever the theme re-renders the drawer or cart page.
  var lastCart = null;
  function observe() {
    var mo = new MutationObserver(function () {
      if (busy) return;
      json('/cart.js').then(function (c) { lastCart = c; decorate(c); });
    });
    ['[data-drawer-body]', '[data-cart-wrapper]'].forEach(function (sel) {
      var n = document.querySelector(sel);
      if (n) mo.observe(n, { childList: true });
    });
  }

  function boot() {
    wrap();
    observe();
    var css = document.createElement('style');
    css.textContent = '.gi-sp-line{display:none!important}' +
      '.gi-sp{display:flex;align-items:center;gap:12px;margin:12px 0;padding:12px 14px;border:1px solid #f2f2f2;border-radius:12px;background:#fff;color:#000;text-align:left}' +
      '.gi-sp.is-on{border-color:#bc9a70;background:#f3efec}' +
      '.gi-sp svg{flex:0 0 26px}.gi-sp__text{flex:1;display:flex;flex-direction:column;gap:2px;font-size:14px;line-height:1.35}' +
      '.gi-sp__text span{font-size:12px;color:#767676}' +
      '.gi-sp__switch{flex:0 0 52px;width:52px;height:30px;border-radius:15px;border:0;padding:3px;cursor:pointer;background:#c4c4c4;display:flex;justify-content:flex-start;transition:background .15s}' +
      '.gi-sp__switch span{width:24px;height:24px;border-radius:50%;background:#fff;display:block}' +
      '.gi-sp.is-on .gi-sp__switch{background:#000;justify-content:flex-end}' +
      '.gi-sp__switch:focus-visible{outline:2px solid #000;outline-offset:2px}';
    document.head.appendChild(css);
    var keys = function (c) { return c.items.map(function (i) { return i.key + ':' + i.quantity; }).join(','); };
    json('/cart.js').then(function (c0) {
      return sync(c0).then(function (c) {
        lastCart = c;
        if (keys(c) !== keys(c0) && location.pathname.indexOf('/cart') === 0 && typeof window.cartPageUpdate === 'function') window.cartPageUpdate(c);
        decorate(c);
      });
    });
  }

  window.GIShipProtect = { sync: sync, decorate: decorate };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
